import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ActionType } from '../types';

const StyledDialog = styled(Dialog)`
    & .MuiDialog-paper {
        width: 500px;
    }
` as typeof Dialog;

type PublishTemplateModalProps = DialogProps & {
    actionType: ActionType;
    handleUpdate: () => void;
};

const UpdateTemplateStatusModal = (props: PublishTemplateModalProps) => {
    const { actionType, handleUpdate, onClose, ...other } = props;

    const { t } = useTranslation('templates');

    const title = actionType === ActionType.Publish ? t('publish-template') : t('unpublish-template');
    const infoMessage =
        actionType === ActionType.Publish ? t('publish-template-info-message') : t('unpublish-template-info-message');
    const updateButtonText = actionType === ActionType.Publish ? t('publish') : t('unpublish');

    const handleClose = () => {
        onClose?.({}, 'backdropClick');
    };

    return (
        <StyledDialog onClose={handleClose} {...other}>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>{infoMessage}</DialogContent>

            <DialogActions>
                <Button onClick={handleClose} variant="outlined">
                    {t('cancel')}
                </Button>

                <Button variant="contained" onClick={handleUpdate}>
                    {updateButtonText}
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default UpdateTemplateStatusModal;
